import {makeChannelOptionHtml} from "./ChannelOptionHtml";

export function makePegiPegiChannelOptionHtml() {
    const innerHtml = '<span style="color:#4F4E4E;">Pegi</span><span style="color:#F97432;">pegi</span>'
    const html = makeChannelOptionHtml(innerHtml, [
        'background: white',
    ]);
    return html;
}
